export default {
  leftPercent: 0,
  rightPercent: 100,
  start: null,
  end: null
};
